import store from '../store/store'

let auth = (to, from, next) => {
  if (!store.getters['auth/guest']) {
    next()
  } else {
    next({name: 'login'})
  }
}

let guest = (to, from, next) => {
  if (store.getters['auth/guest']) {
    next()
  } else {
    next({name: 'home'})
  }
}

export {
  auth,
  guest,
}



// WEBPACK FOOTER //
// ./src/router/middlewares.js